function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { post, AuthenticationTypes } from '@shared/services/http/httpProtocol';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Spza,
    setBearerHeader: true
};
export const ReportReviewQueryStrings = {
    ApiVersion: 'api-version'
};
export function createReportReview(_0) {
    return _async_to_generator(function*({ itemReport, communityAPI, communityAPIVersion }) {
        try {
            yield post(`${communityAPI}/report`, commonHttpOptions).addQueryEntry(ReportReviewQueryStrings.ApiVersion, communityAPIVersion).setData(itemReport).request();
            return true;
        } catch (error) {
            return false;
        }
    }).apply(this, arguments);
}
